export default __webpack_public_path__ + "static/media/sip-logotype-d.52d536f1.svg";